import React, { memo } from "react";
import WhatsAppPricePlans from "../WhatsAppPricePlans";

/**
 * Manage WhatsApp Accounts — Price plans submodule.
 */
const WhatsAppPricePlan = memo(function WhatsAppPricePlan({
  activeOnly = false,
  editable = true,
  refreshSignal = 0,
  openCreateSignal = 0,
}) {
  return (
    <WhatsAppPricePlans
      activeOnly={activeOnly}
      showHeader={false}
      editable={editable}
      refreshSignal={refreshSignal}
      openCreateSignal={openCreateSignal}
    />
  );
});

export default WhatsAppPricePlan;
